import { useLayoutEffect, useRef } from "react";

import { usePatternBackground } from "providers/pattern-background";
import BluePattern from "Assets/patterns/blue.json";

// The page's own ground, --background in styles/tokens.scss. The app's
// pattern canvas sits outside the token scope, so it takes the value itself.
const PAGE_GROUND = "#f7f5f1";

/**
 * Replaces the app-wide speckled canvas with the portal's plain ground while
 * the company portal is open. The canvas is fixed behind every page, and an
 * overscroll bounce shows whatever is behind the page. The learner app is
 * drawn to show the pattern, so it goes back on the way out.
 *
 * The body takes the same ground: Chrome's bounce shows the fixed canvas,
 * but Safari's paints the body's background, which is otherwise unset.
 *
 * Called by the portal shell rather than a page, so it holds across portal
 * navigation and takes effect while a route's access check is still in
 * flight.
 *
 * A layout effect, so the switch lands before the browser paints: a pending
 * route's first render is empty over the patterned canvas, and a passive
 * effect would let that one frame through.
 *
 * The provider hands out a new function each render; holding the first in a
 * ref keeps this to one switch on mount and one on unmount, instead of
 * toggling on every render of the provider.
 */
export function usePlainBackground() {
  const pattern = useRef(usePatternBackground());

  useLayoutEffect(() => {
    const { onChangeColors } = pattern.current;
    const body = document.body.style;
    const bodyBefore = body.backgroundColor;

    onChangeColors(BluePattern.color.pattern.value, false, PAGE_GROUND, false);
    body.backgroundColor = PAGE_GROUND;

    return () => {
      onChangeColors(
        BluePattern.color.pattern.value,
        false,
        "transparent",
        true
      );
      body.backgroundColor = bodyBefore;
    };
  }, []);
}
